import { LazyImage } from '../LazyImage';
import * as styles from './styles.css';
import calendarImage from './assets/calendar.png';
import { LinkButton, useDeviceType } from '@cian/ui-kit';
import { useLinkButtonProps } from 'shared/hooks';
import { REQUIREMENTS_FOR_XML_LINK } from 'shared/constants/links';
import { clsx } from 'clsx';

export const ChangeTechRecXML: React.FC = () => {
  const linkButtonProps = useLinkButtonProps();
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>Изменение технических требований для XML-выгрузки</div>
      <div className={styles['banner']}>
        <div className={styles['text-block']}>
          <div className={styles['banner-title']}>
            С 20 апреля информация о продвижении будет передаваться в новом теге — AuctionPerClick
          </div>
          <div className={styles['banner-description']}>
            Передайте информацию об изменениях техническим специалистам вашей CRM системы и запросите внесение доработок
            в XML-фид и в CRM систему до 17 апреля 2026
          </div>
        </div>
        <LazyImage
          wrapperClassName={styles['image-wrapper']}
          src={calendarImage}
          alt="calendar"
          className={styles['image']}
        />
      </div>
      <div className={styles['btn']}>
        <LinkButton {...linkButtonProps} href={REQUIREMENTS_FOR_XML_LINK}>
          Требования для XML
        </LinkButton>
      </div>
    </div>
  );
};
